

















































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { List, Sticky } from 'vant';
import SearchBar from '@/components/next/SearchBar.vue';
import { getVoteList, getBaseInfo } from '../api';

Vue.use(List).use(Sticky);

type TabIndexKeyName = 'activeGroupIndex' | 'activeCateIndex';

@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  timer: any = null;
  currentTime: number = 0;
  endTime: number = 0;
  startTime: number = 0;
  voteAvaliable = true;

  tabGroup: string[] = ['专业组', '社会组'];
  tabCate: any[] = [
    {
      title: '广告招贴类',
      id: 2,
    },
    {
      title: '数字影像类',
      id: 1,
    },
    {
      title: '文创设计类',
      id: 3,
    },
  ];

  activeGroupIndex = 0;
  activeCateIndex = 0;

  keyword = '';
  loading = false;
  finished = false;
  page = 1;
  list: any[] = [];

  async created() {
    const retBaseInfo = await getBaseInfo();
    this.timer = setInterval(() => {
      this.currentTime = new Date().getTime();
    }, 1000);

    this.endTime = new Date(Number(retBaseInfo.data.endTime) * 1000).getTime();
    this.startTime = new Date(
      Number(retBaseInfo.data.startTime) * 1000,
    ).getTime();
    // 查看
    this.onGetVoteList();
    // 标记用户打开过首页了
    (window as any).viewedHomePage = 1;
  }

  @Watch('currentTime')
  onCurrentTimeChange(newval: number) {
    if (this.currentTime >= this.endTime) {
      this.voteAvaliable = false;
      clearInterval(this.timer);
    } else if (this.currentTime < this.startTime) {
      this.voteAvaliable = false;
    } else {
      this.voteAvaliable = true;
    }
  }

  get resetTime() {
    let s = 0;
    let m = 0;
    let h = 0;

    if (this.currentTime && this.endTime) {
      // 判断活动是否开始
      if (this.currentTime >= this.startTime) {
        s = (this.endTime - this.currentTime) / 1000;
        m = s / 60;
        h = m / 60;
      } else {
        s = (this.startTime - this.currentTime) / 1000;
        m = s / 60;
        h = m / 60;
      }
    }
    return {
      h: Math.floor(h),
      m: Math.floor(m % 60),
      s: Math.floor(s % 60),
    };
  }

  onTabChange(index: number, keyName: TabIndexKeyName) {
    this[keyName] = index;
    this.reset();
    this.onGetVoteList();
  }

  async onGetVoteList() {
    this.loading = true;
    const ret = await getVoteList({
      page: this.page,
      search: this.keyword,
      group: this.activeGroupIndex + 1,
      work_type: this.tabCate[this.activeCateIndex].id,
    });
    this.loading = false;
    if (!ret.data.length) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...ret.data];
      this.page++;
    }
  }

  onListItemClick(item: any, index: number) {
    this.$routerThen
      .push({
        url: `detail?id=${item.id}`,
      })
      .then((vm) => {
        vm.$on('updateZan', () => {
          this.list[index].votes = Number(this.list[index].votes) + 1;
        });
      });
  }
  onSearch() {
    this.reset();
    this.onGetVoteList();
  }

  onClear() {
    this.reset();
    this.onGetVoteList();
  }

  reset() {
    this.finished = false;
    this.list = [];
    this.page = 1;
  }
}
